export default __webpack_public_path__ + "static/MikeMooney-32504ab75e038019e37c5613be4504e0.jpg";